import type React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';

export const CircleIcon: React.FC<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ className, ...props }) => {
  return (
    <div
      className={cs(
        'tw-flex tw-items-center tw-justify-center',
        'tw-h-8 tw-w-8',
        'tw-rounded-full tw-shadow',
        'tw-bg-primary-50 tw-text-primary-800',
        className
      )}
      {...props}
    />
  );
};
